import Vue from "vue";
import Vuex from "vuex";
import Base from "./modules/base";
import Auth from "./modules/auth";
import Cards from "./modules/cards";
import Stores from "./modules/stores";
import Wallet from "./modules/wallet";
import AlterWallet from "./modules/alterWallet";
import GenerateCards from "./modules/generateCards";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    Base,
    Auth,
    Cards,
    Stores,
    Wallet,
    AlterWallet,
    GenerateCards,
  },
});
